export const DEFAULT_MAX_DURATION = 10;
export const DEFAULT_SAMPLE_RATE = 16000;
export const DEFAULT_CHANNELS = 1;
export const DEFAULT_AUDIO_MIME_TYPE = 'audio/wav';

export const DEFAULT_SILENCE_THRESHOLD_DB = -48;
export const DEFAULT_SILENCE_DURATION_SECONDS = 1.5;
export const DEFAULT_FFT_SIZE = 2048;

export enum SpeechRecognitionLanguage {
  ENGLISH = 'en-US',
}
